/**
 * @file: 查询最近一条历史记录，并从存储中删除
 * @author: xiaolong.huang@dmall.com
 */

import Storage from '../../../storage/index';
import Utils from '../../../utils/util';
import Config from '../../../config/index';

async function historyPop(): Promise<StackOutItem|null> {
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let lastItem: HistoryItem|null = await getLastItem(paperId);

    if (!lastItem) {
        return Promise.resolve(null);
    }

    let type: HistoryType = lastItem.type;
    let actionId: string = lastItem.actionId;
    let listSrc: HistoryItem[] = await getByType(paperId, type);
    let listStepOne: HistoryItem[] = Utils.getSameItemFromList(listSrc, {actionId});
    let listMerge: StackOutItem|null = mergeStepList(listStepOne);

    Storage.del({
        tableName: 'history',
        query: {
            actionId
        }
    });
    return Promise.resolve(listMerge);
}

function getLastItem(paperId: number): Promise<HistoryItem|null> {
    return Storage.get({
        tableName: 'history',
        query: {
            paperId
        }
    }).then((pageList: Array<HistoryItem>): Promise<HistoryItem|null> => {
        if (pageList.length) {
            return Promise.resolve(pageList[pageList.length - 1]);
        }

        return Promise.resolve(null);
    });
}

function getByType(paperId: number, type: HistoryType): Promise<HistoryItem[]> {
    return Storage.get({
        tableName: 'history',
        query: {
            paperId,
            type
        }
    }).then((pageList: HistoryItem[]): Promise<HistoryItem[]> => {
        return Promise.resolve(pageList);
    });
}

function mergeStepList(stepList: HistoryItem[]): StackOutItem|null {
    let result: StackOutItem|null = {
        type: 'add',
        extendParams: {},
        data: []
    };

    if (!stepList.length) {
        result = null;
    }

    stepList.forEach((step: HistoryItem): void => {
        result.type = step.type;
        result.extendParams = step.extendParams;
        result.data = result.data.concat(step.data);
    });

    return result;
}

export {
    historyPop
};
